import axios from "axios";
import axiosClient from "./axiosClient";

const username = "SQL01UAT";
const password = "btR/RLAB95C2XR9pxSYnaQ==";

function toApiErrorPayload(error) {
  if (error?.isRefreshNetworkError || !error?.response) {
    return {
      Status: {
        isNetworkError: true,
        code: error?.code,
        message: error?.message,
      },
    };
  }

  return { Status: error.response };
}

// login vs Domain
export const POST_TOKEN_DOAMAIN = (Url, Body, handleData) => {
  axios
    .post(Url, Body, {
      auth: {
        username: username,
        password: password,
      },
    })
    .then((res) => {
      handleData(res.data);
    })
    .catch(function (error) {
      if (error.response) {
        handleData({ Status: error.response });
      }
    });
};

//
export const POST_DATA_NOTOKEN_MYAPI = (Url, Data, HandleDate) => {
  axiosClient
    .post(Url, Data, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    })
    .then((res) => {
      HandleDate(res.data);
    })
    .catch(function (error) {
      HandleDate(toApiErrorPayload(error));
    });
};

export const GET_TOKEN_MYAPI = (Url, Data, HandleDate) => {
  axios
    .post(Url, Data, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      HandleDate(res.data);
    })
    .catch(function (error) {
      HandleDate({ Status: error.response });
    });
};
export const GET_TOKEN_MYAPI_RECAPTCHA = (
  Url,
  RecaptchaToken,
  Data,
  HandleDate
) => {
  axiosClient
    .post(Url, Data, {
      headers: {
        "Content-Type": "application/json",
        "X-Recaptcha-Token-v3": RecaptchaToken.token_v3,
        "X-Recaptcha-Token-v2": RecaptchaToken.token_v2,
      },
      withCredentials: true,
    })
    .then((res) => {
      HandleDate(res.data);
    })
    .catch(function (error) {
      HandleDate(toApiErrorPayload(error));
    });
};
export const POST_MYAPI = (Url, Data, Token, HandleDate) => {
  axios
    .post(Url, Data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      },
    })
    .then((res) => {
      HandleDate(res.data);
    })
    .catch(function (error) {
      HandleDate({ Status: error.response });
    });
};

export const POST_MYAPI_UPLOAD_FILE = (Url, Data, Token, HandleDate) => {
  axios
    .post(Url, Data, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${Token}`,
      },
    })
    .then((res) => {
      HandleDate(res.data);
    })
    .catch(function (error) {
      HandleDate({ Status: error.response });
    });
};

export const GET_MYAPI_TOKEN = (url, token, handleData) => {
  axios
    .get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      handleData({ Status: "success", Response: res });
    })
    .catch(function (error) {
      handleData({ Status: "fail", Response: error.response });
    });
};
export const GET_MYAPI_NOT_TOKEN = (url, handleData) => {
  axios
    .get(url, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      handleData({ Status: "success", Response: res });
    })
    .catch(function (error) {
      handleData({ Status: "fail", Response: error.response });
    });
};

export const GET_MYAPI_WITH_CREDENTIALS = (url, handleData) => {
  axiosClient
    .get(url, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    })
    .then((res) => {
      handleData(res.data);
    })
    .catch(function (error) {
      handleData(toApiErrorPayload(error));
    });
};

export const GET_MYAPI_BLOB_WITH_CREDENTIALS = (url, handleData) => {
  axiosClient
    .get(url, {
      responseType: "blob",
      withCredentials: true,
    })
    .then((res) => {
      handleData(res.data);
    })
    .catch(async function (error) {
      const data = error?.response?.data;
      if (data instanceof Blob) {
        try {
          const json = JSON.parse(await data.text());
          handleData({
            Status: {
              status: error.response.status,
              data: json,
            },
          });
          return;
        } catch {}
      }
      handleData(toApiErrorPayload(error));
    });
};

export const POST_MYAPI_WITH_CREDENTIALS = (url, data, handleData) => {
  axiosClient
    .post(url, data ?? {}, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    })
    .then((res) => {
      handleData(res.data);
    })
    .catch(function (error) {
      handleData(toApiErrorPayload(error));
    });
};
